import React from "react";

const CommentBigTwo = () => {
  return (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.9358 30.66L34.7158 36.98C34.9158 38.64 33.1358 39.7999 31.7158 38.9399L23.3358 33.96C22.4158 33.96 21.5158 33.9 20.6358 33.78C22.1158 32.04 22.9958 29.84 22.9958 27.46C22.9958 21.78 18.0758 17.1801 11.9958 17.1801C9.67579 17.1801 7.5358 17.84 5.7558 19C5.6958 18.5 5.67578 18 5.67578 17.48C5.67578 8.37998 13.5758 1 23.3358 1C33.0958 1 40.9958 8.37998 40.9958 17.48C40.9958 22.88 38.2158 27.66 33.9358 30.66Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M23 27.4601C23 29.8401 22.12 32.0402 20.64 33.7802C18.66 36.1802 15.52 37.7201 12 37.7201L6.78 40.8201C5.9 41.3601 4.77999 40.6201 4.89999 39.6001L5.39999 35.6602C2.71999 33.8002 1 30.8201 1 27.4601C1 23.9401 2.88001 20.8401 5.76001 19.0001C7.54001 17.8401 9.68 17.1802 12 17.1802C18.08 17.1802 23 21.7801 23 27.4601Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CommentBigTwo;
